module.exports = __webpack_public_path__ + "img/intro@3x.14ef1c85.png";